import { makeVar, gql, useQuery } from '@apollo/client';
export const isPageRoutingVar = makeVar(false);
export const isPageRoutingCachePolicy = {
    isPageRouting: {
        read() {
            return isPageRoutingVar();
        },
    },
};
export const isPageRoutingTypeDefs = gql `
    extend type Query {
        isPageRouting: Boolean!
    }
`;
const ROUTE_QUERY = gql `
    query isPageRouting {
        isPageRouting @client
    }
`;
export function usePageRouting() {
    var _a, _b;
    function setIsPageRoutingState(value) {
        isPageRoutingVar(value);
    }
    const routingState = useQuery(ROUTE_QUERY, { ssr: false });
    return { isPageRouting: (_b = (_a = routingState.data) === null || _a === void 0 ? void 0 : _a.isPageRouting) !== null && _b !== void 0 ? _b : false, setIsPageRoutingState };
}
